"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSearchMainSaga = fetchSearchMainSaga;
exports.fetchSearchSaga = fetchSearchSaga;
exports.fetchSearchEventsSaga = fetchSearchEventsSaga;
exports.searchProviderSaga = searchProviderSaga;
const effects_1 = require("redux-saga/effects");
const selectors_1 = require("../LanguagesProvider/selectors");
const errors_1 = require("../../utils/errors");
const saga_1 = require("../ConfigProvider/saga");
const ConfigProvider_1 = require("../ConfigProvider");
const saga_2 = require("../EventsProvider/saga");
const api_1 = require("../../api/search/api");
const api_2 = require("../../api/events/api");
const api_3 = require("../../api/tournaments/api");
const utils_1 = require("../../utils");
const slice_1 = require("./slice");
const selectors_2 = require("./selectors");
const constants_1 = require("./constants");
function* fetchSearchMainSaga(action) {
    try {
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearch());
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const query = yield (0, effects_1.select)(selectors_2.selectInputSearch);
        const { minQueryLength, searchDelay } = action.payload.searchConfig || constants_1.SEARCH_CONFIG;
        if (query.length > minQueryLength) {
            yield (0, effects_1.delay)(searchDelay);
            const { data } = yield (0, effects_1.call)(api_1.searchEntities, {
                query,
                locale,
            });
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchMainSuccess(data));
        }
        else {
            const message = 'The string length must be greater than 3 characters';
            const error = (0, errors_1.createUnknownError)(message);
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchError(error));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchMainError(error));
    }
}
function* fetchEventsSearchSaga({ request, }) {
    const searchQuery = yield (0, effects_1.select)(selectors_2.selectInputSearch);
    const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
    let result = { items: [] };
    const newEventsEndpointEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.NEW_EVENTS_ENDPOINT);
    const tokenizeSearchQuery = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.TOKENIZE_SEARCH_QUERY_ENABLED);
    if (newEventsEndpointEnabled) {
        const req = {
            searchQuery: tokenizeSearchQuery ? (0, utils_1.tokenize)(searchQuery) : searchQuery,
            locale,
            ...request,
        };
        const { resData } = yield (0, effects_1.call)(saga_2.fetchEventsApi, req);
        result = resData;
    }
    else {
        const req = {
            query: searchQuery,
            locale,
        };
        const response = yield (0, effects_1.call)(api_2.searchEvents, req);
        result = response.data;
    }
    return result;
}
function* fetchTournamentsSearchSaga({ request, }) {
    const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
    const searchQuery = yield (0, effects_1.select)(selectors_2.selectInputSearch);
    let result = { items: [] };
    const newTournamentsEndpointEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.NEW_TOURNAMENTS_ENDPOINT);
    const tokenizeSearchQuery = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.TOKENIZE_SEARCH_QUERY_ENABLED);
    if (newTournamentsEndpointEnabled) {
        const req = {
            searchQuery: tokenizeSearchQuery ? (0, utils_1.tokenize)(searchQuery) : searchQuery,
            locale,
            ...request,
        };
        const response = yield (0, effects_1.call)(api_3.getTournamentsV2, req);
        result = response.data;
    }
    else {
        const req = {
            query: searchQuery,
            locale,
        };
        const response = yield (0, effects_1.call)(api_3.searchTournaments, req);
        result = response.data;
    }
    return result;
}
function* fetchSearchSaga(action) {
    try {
        const { withLoader = true, searchConfig = constants_1.SEARCH_CONFIG, tournamentsSearchRequest, eventsSearchRequest, } = action.payload;
        if (withLoader) {
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearch());
        }
        const query = yield (0, effects_1.select)(selectors_2.selectInputSearch);
        const { minQueryLength, searchDelay } = searchConfig;
        if (query.length > minQueryLength) {
            yield (0, effects_1.delay)(searchDelay);
            const [tournamentsList, eventsList] = yield (0, effects_1.all)([
                (0, effects_1.call)(fetchTournamentsSearchSaga, {
                    request: tournamentsSearchRequest,
                }),
                (0, effects_1.call)(fetchEventsSearchSaga, {
                    request: eventsSearchRequest,
                }),
            ]);
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchSuccess({
                entriesEvents: eventsList,
                entriesTournaments: tournamentsList,
            }));
            yield (0, effects_1.put)(slice_1.searchProviderActions.setRecentSearch(query));
        }
        else {
            const message = 'The string length must be greater than 3 characters';
            const error = (0, errors_1.createUnknownError)(message);
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchError(error));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchError(error));
    }
}
function* fetchSearchEventsSaga(action) {
    try {
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearch());
        const isTournaments = yield (0, effects_1.select)(selectors_2.selectSearchIsTournaments);
        const sportId = yield (0, effects_1.select)(selectors_2.selectSportId);
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const query = yield (0, effects_1.select)(selectors_2.selectInputSearchLine);
        const { minQueryLength, searchDelay } = action.payload.searchConfig || constants_1.SEARCH_CONFIG;
        if (query.length > minQueryLength) {
            yield (0, effects_1.delay)(searchDelay);
            if (!isTournaments) {
                const { data: resDataEvents } = yield (0, effects_1.call)(api_2.searchEvents, {
                    query,
                    sportId,
                    locale,
                });
                yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchSuccess({
                    entriesEvents: resDataEvents,
                }));
            }
            yield (0, effects_1.put)(slice_1.searchProviderActions.setRecentSearch(query));
        }
        else {
            const message = 'The string length must be greater than 3 characters else no tournaments';
            const error = (0, errors_1.createUnknownError)(message);
            yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchError(error));
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        yield (0, effects_1.put)(slice_1.searchProviderActions.fetchSearchError(error));
    }
}
function* searchProviderSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.searchProviderActions.setSearchMain.type, fetchSearchMainSaga),
        (0, effects_1.takeLatest)(slice_1.searchProviderActions.setSearchTab.type, fetchSearchSaga),
        (0, effects_1.takeLatest)(slice_1.searchProviderActions.setSearch.type, fetchSearchSaga),
        (0, effects_1.takeLatest)(slice_1.searchProviderActions.setSearchLine.type, fetchSearchEventsSaga),
    ]);
}
//# sourceMappingURL=saga.js.map